// Paddo LP — behaviour added section by section

(function () {
  var MOBILE_BP = 810;

  // 5. Columns — responsive reorder
  function initColumns(section) {
    var grid = section.querySelector('.paddo__columns-grid');
    if (!grid) return;

    var items = Array.from(grid.children);
    var sorted = { d: [], m: [] };

    function rank(el, prop) {
      var v = getComputedStyle(el).getPropertyValue(prop);
      return parseInt(v, 10) || 0;
    }

    function snapshot(key, prop) {
      sorted[key] = items.slice().sort(function (a, b) {
        return rank(a, prop) - rank(b, prop);
      });
    }

    snapshot('d', '--order-d');
    snapshot('m', '--order-m');

    var current = null;

    function apply() {
      var key = window.innerWidth < MOBILE_BP ? 'm' : 'd';
      if (key === current) return;
      current = key;
      sorted[key].forEach(function (el) { grid.appendChild(el); });
    }

    apply();
    window.addEventListener('resize', apply);

    return function () { window.removeEventListener('resize', apply); };
  }

  // 6. Carousel — infinite loop, dot indicators, click-to-slide
  function initCarousel(section) {
    var track = section.querySelector('[data-paddo-carousel]');
    var dotsWrap = section.querySelector('[data-paddo-carousel-dots]');
    if (!track || !dotsWrap) return;

    var dots = Array.from(dotsWrap.querySelectorAll('.paddo__carousel-dot'));
    var originals = Array.from(track.querySelectorAll('.paddo__carousel-slide'));
    var count = originals.length;
    if (count < 2) return;

    function makeClone(s) {
      var c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('id');
      return c;
    }

    var current = 0;
    var jumping = false;
    var clonesInserted = false;

    function gap() {
      return parseFloat(getComputedStyle(track).columnGap) || 20;
    }

    function slideW() {
      return originals[0].offsetWidth + gap();
    }

    function insertClones() {
      if (clonesInserted) return;
      clonesInserted = true;

      var frag = document.createDocumentFragment();
      originals.forEach(function (s) { frag.appendChild(makeClone(s)); });
      track.appendChild(frag);

      var preFrag = document.createDocumentFragment();
      originals.forEach(function (s) { preFrag.appendChild(makeClone(s)); });
      track.insertBefore(preFrag, track.firstChild);

      track.style.scrollBehavior = 'auto';
      track.scrollLeft += slideW() * count;
      track.style.scrollBehavior = '';
    }

    function setDot(idx) {
      var wrapped = ((idx % count) + count) % count;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === wrapped); });
    }

    setDot(0);

    function checkBounds() {
      if (jumping || !clonesInserted) return;
      var sw = slideW();
      var setLen = sw * count;
      var originalsStart = setLen;
      var originalsEnd = setLen * 2;

      if (track.scrollLeft >= originalsEnd) {
        jumping = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft -= setLen;
        track.style.scrollBehavior = '';
        jumping = false;
      } else if (track.scrollLeft < originalsStart - setLen + sw) {
        jumping = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft += setLen;
        track.style.scrollBehavior = '';
        jumping = false;
      }
    }

    function onScrollEnd() {
      insertClones();
      checkBounds();
    }

    var scrollTimer;
    function onScroll() {
      if (jumping) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(onScrollEnd, 100);

      var sw = slideW();
      var offset = clonesInserted ? sw * count : 0;
      var idx = Math.round((track.scrollLeft - offset) / sw);
      idx = ((idx % count) + count) % count;
      if (idx !== current) {
        current = idx;
        setDot(current);
      }
    }

    track.addEventListener('scrollend', onScrollEnd);
    track.addEventListener('scroll', onScroll);

    var autoStopped = false;
    var paused = false;
    var timer = setInterval(function () {
      if (!paused) track.scrollBy({ left: slideW(), behavior: 'smooth' });
    }, 2500);

    function stopAuto() {
      if (autoStopped) return;
      autoStopped = true;
      clearInterval(timer);
    }

    track.addEventListener('pointerdown', stopAuto);

    function onMouseEnter() { paused = true; }
    function onMouseLeave() { paused = false; }
    track.addEventListener('mouseenter', onMouseEnter);
    track.addEventListener('mouseleave', onMouseLeave);

    var dotHandlers = [];
    dots.forEach(function (dot) {
      var handler = function () {
        stopAuto();
        var idx = parseInt(dot.getAttribute('data-slide'), 10);
        var sw = slideW();
        var offset = clonesInserted ? sw * count : 0;
        track.scrollTo({ left: offset + sw * idx, behavior: 'smooth' });
      };
      dot.addEventListener('click', handler);
      dotHandlers.push({ el: dot, fn: handler });
    });

    return function () {
      clearInterval(timer);
      clearTimeout(scrollTimer);
      track.removeEventListener('scrollend', onScrollEnd);
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('pointerdown', stopAuto);
      track.removeEventListener('mouseenter', onMouseEnter);
      track.removeEventListener('mouseleave', onMouseLeave);
      dotHandlers.forEach(function (d) { d.el.removeEventListener('click', d.fn); });
    };
  }

  // 7. Swatches — gallery thumbnail switcher
  function initSwatches(section) {
    var wrap = section.querySelector('[data-paddo-swatches]');
    if (!wrap) return;

    var video = wrap.querySelector('[data-swatch-video]');
    var items = Array.from(wrap.querySelectorAll('[data-swatch-gallery]'));
    var thumbs = Array.from(wrap.querySelectorAll('[data-swatch-idx]'));
    if (!thumbs.length) return;

    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (img) {
        img.loading = 'eager';
        var preload = new Image();
        preload.src = img.src;
      }
    });

    var thumbHandlers = [];
    thumbs.forEach(function (btn) {
      var handler = function () {
        var idx = btn.getAttribute('data-swatch-idx');

        if (video) { video.remove(); video = null; }

        items.forEach(function (item) {
          var show = item.getAttribute('data-swatch-gallery') === idx;
          if (show) item.removeAttribute('hidden');
          else item.setAttribute('hidden', '');
        });

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      };
      btn.addEventListener('click', handler);
      thumbHandlers.push({ el: btn, fn: handler });
    });

    return function () {
      thumbHandlers.forEach(function (d) { d.el.removeEventListener('click', d.fn); });
    };
  }

  function initSection(section) {
    var teardowns = [
      initColumns(section),
      initCarousel(section),
      initSwatches(section)
    ].filter(Boolean);
    section._paddoTeardowns = teardowns;
  }

  function destroySection(section) {
    if (!section._paddoTeardowns) return;
    section._paddoTeardowns.forEach(function (fn) { fn(); });
    delete section._paddoTeardowns;
  }

  // Initial load
  var section = document.querySelector('.paddo-lp');
  if (section) initSection(section);

  // Theme editor: reinitialize on section reload
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.classList.contains('paddo-lp')) return;
    initSection(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target.classList.contains('paddo-lp')) return;
    destroySection(e.target);
  });
})();
